import React, { useState, useEffect } from "react";
import { Dropdown, Row, Nav, Tab, Collapse } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import ForgetPasswordModal from "../../components/superAdmin/ForgetPasswordModal";
import { IMAGES } from "../../constant/theme";
import {
  downloadCoachDailyAttendances,
  getCoachDailyAttendance,
  getPlayersAttendanceByLogin,
  getSession,
  getStatus,
} from "../../../services/academicService";
import CoachAttendenceQrModal from "../../components/qr/CoachAttendenceQrModal";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDate, formatHoursMinutes } from "../../../utils/helperFunction";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const options = [
  //{ value: '1', label: 'Select Status' },
  { value: "2", label: "Published" },
  { value: "3", label: "Draft" },
  { value: "4", label: "Trash" },
  { value: "5", label: "Private" },
  { value: "6", label: "Pending" },
];

const theadData = [
  { heading: "S.No", sortingVale: "sno" },
  { heading: "Session", sortingVale: "session" },
  { heading: "Attendance Date", sortingVale: "date" },
  { heading: "Status", sortingVale: "status" },
];

const svg1 = (
  <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24"></rect>
      <circle fill="#000000" cx="5" cy="12" r="2"></circle>
      <circle fill="#000000" cx="12" cy="12" r="2"></circle>
      <circle fill="#000000" cx="19" cy="12" r="2"></circle>
    </g>
  </svg>
);

const PlayersAttendance = () => {
  const [forgetModal, setForgetModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [currentStart, setCurrentStart] = useState(0);

  // pagination & search
  const [page, setPage] = useState(0); // 0-based
  const [size, setSize] = useState(10); // page size
  const [search, setSearch] = useState(""); // search text
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [qrCodeModal, setQrCodeModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [session, setSession] = useState([]);
  const [status, setStatus] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  // sorting icon state (you can later connect this with API sort params)
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });

  // ---- API CALL WITH page, size, search ----
  async function fetchUserData({
    page,
    size,
    search,
    startDate,
    endDate,
    selectedSession,
    selectedStatus,
  }) {
    setLoading(true);
    try {
      const res = await getPlayersAttendanceByLogin(
        page,
        size,
        search,
        startDate,
        endDate,
        selectedSession,
        selectedStatus,
      );
      setUserData(res?.content || []);
      setTotalElements(res?.totalElements || 0);
      setTotalPages(res?.totalPages || 0);
      setCurrentStart(res?.number || 0);
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  }

  // initial & whenever page/size/search changes
  useEffect(() => {
    fetchUserData({
      page,
      size,
      search,
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      selectedSession,
      selectedStatus,
    });
  }, [page, size, search, startDate, endDate, selectedSession, selectedStatus]);

  // ---- client sorting (optional; if you want server-side sort, pass sort to API instead) ----
  function SotingData(name) {
    const sortedPeople = [...userData];
    switch (name) {
      case "name":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name),
        );
        break;

      case "email":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name),
        );
        break;

      case "landLine":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a.landLine || "").localeCompare(b.landLine || "")
            : (b.landLine || "").localeCompare(a.landLine || ""),
        );
        break;

      case "phone":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a.phone || "").localeCompare(b.phone || "")
            : (b.phone || "").localeCompare(a.phone || ""),
        );
        break;

      default:
        break;
    }
    setUserData(sortedPeople);
  }

  // ---- Search handler ----
  function handleSearchChange(e) {
    const value = e.target.value;
    setSearch(value);
    setPage(0); // reset to first page on search
  }

  // ---- Pagination helpers ----

  useEffect(() => {
    fetchSession();
    fetchStatus();
  }, []);

  async function fetchSession() {
    try {
      const res = await getSession();
      setSession(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  async function fetchStatus() {
    try {
      const res = await getStatus();
      setStatus(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  const sessionOptions = [
    { value: "", label: "Select Session" },
    ...(Array.isArray(session) ? session : []).map((s) => ({
      value: s?.id,
      label: s?.name,
    })),
  ];

  const statusOptions = [
    { value: "", label: "Select Status" },
    ...(Array.isArray(status) ? status : []).map((s) => ({
      value: s?.value,
      label: s?.label,
    })),
  ];

  const downloadExcel = async () => {
    try {
      const res = await downloadCoachDailyAttendances(
        search,
        startDate,
        endDate,
        selectedSession,
        selectedStatus,
      );

      const formattedData = res?.content?.map((data, index) => ({
        "S.No": index + 1,
        "Coach Name": data?.coach?.name,
        "CheckIn Time": data?.checkInTime
          ? new Date(data.checkInTime).toLocaleString()
          : "",
        "CheckOut Time": data?.checkOutTime
          ? new Date(data.checkOutTime).toLocaleString()
          : "",
        "Session Name": data?.session?.name,
        "Session Type": data?.session?.sessionType,
        "Session Start Time": data?.sessionStartTime,
        "Session End Time": data?.sessionEndTime,
        "Total Hours": formatHoursMinutes(data?.totalHours),
        "Attendance Status": data?.attendenceStatus,
        Reason: data?.reason,
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Members");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const file = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(file, "coaches_attendance.xlsx");
    } catch (error) {
      console.error("Excel download failed:", error);
    }
  };

  return (
    <>
      <PageTitle activeMenu={"Attendance"} motherMenu={"Players"} />
      <div className="filter cm-content-box box-primary">
        <div className={`content-title`} onClick={() => setOpen(!open)}>
          <div className="cpa">
            <i className="fas fa-filter me-2"></i>Filter
          </div>
          <div className="tools">
            <Link
              to={"#"}
              className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
            >
              <i className="fas fa-angle-up"></i>
            </Link>
          </div>
        </div>
        <Collapse in={open}>
          <div className="cm-content-body form excerpt">
            <div className="card-body">
              <div className="row">
                <div className="col-md-2">
                  <label className="form-label">Start Date</label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => {
                      setStartDate(date);
                      setEndDate(null); // reset end date
                    }}
                    maxDate={new Date()}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    placeholderText="Select start date"
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label">End Date</label>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    minDate={startDate}
                    maxDate={
                      startDate
                        ? new Date(
                            new Date(startDate).setDate(
                              startDate.getDate() + 90,
                            ),
                          )
                        : new Date()
                    }
                    disabled={!startDate}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    placeholderText="Select end date"
                  />
                </div>

                <div className="col-xl-3">
                  <label className="form-label">Session</label>
                  <Select
                    isSearchable={false}
                    options={sessionOptions}
                    className="custom-react-select"
                    onChange={(e) => setSelectedSession(e.value)}
                    placeholder="Select Session"
                  />
                </div>

                <div className="col-xl-3 col-sm-3 mb-3 mb-xl-0">
                  <label className="form-label">Status</label>
                  <Select
                    isSearchable={false}
                    options={statusOptions}
                    className="custom-react-select"
                    onChange={(e) => setSelectedStatus(e.value)}
                    placeholder="Select Status"
                  />
                </div>
              </div>
            </div>
          </div>
        </Collapse>
      </div>
      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          <div className="col-lg-12">
            <Nav as="ul" className="nav nav-pills mb-3">
              <Nav.Item as="li">
                <Nav.Link eventKey="List" className="me-1">
                  List View
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li">
                <Nav.Link eventKey="Grid">Grid View</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>

          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              {/* LIST VIEW */}
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Player Attendance</h4>
                    {/* <div>
                      <button
                        className="btn btn-primary m-2"
                        onClick={() => setQrCodeModal(true)}
                      >
                        QR Code
                      </button>
                      <Link to={"/admin/add-coach"} className="btn btn-primary">
                        + Add New
                      </Link>
                    </div> */}
                    {/* <button
                      className="btn btn-primary m-2"
                      onClick={() => downloadExcel()}
                    >
                      Download
                    </button> */}
                  </div>
                  <div className="card-body">
                    <div className="dataTables_wrapper no-footer">
                      <div className="justify-content-between d-sm-flex">
                        {/* PAGE SIZE DROPDOWN */}
                        <div className="dataTables_length">
                          <label className="d-flex align-items-center">
                            Show
                            <Dropdown className="search-drop ms-2 me-2">
                              <Dropdown.Toggle
                                as="div"
                                className="search-drop-btn"
                              >
                                {size}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {[10, 20, 30].map((val) => (
                                  <Dropdown.Item
                                    key={val}
                                    onClick={() => {
                                      setSize(val);
                                      setPage(0);
                                    }}
                                  >
                                    {val}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                            entries
                          </label>
                        </div>

                        {/* SEARCH */}
                        <div className="dataTables_filter">
                          <label>
                            Search :{" "}
                            <input
                              type="search"
                              className=""
                              placeholder=""
                              value={search}
                              onChange={handleSearchChange}
                            />
                          </label>
                        </div>
                      </div>

                      {/* TABLE */}
                      <div className="table-responsive">
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th
                                  key={ind}
                                  onClick={() => {
                                    if (item?.sortingVale === "action") return;
                                    SotingData(item.sortingVale);
                                    setIconDate((prevState) => ({
                                      complete: !prevState.complete,
                                      ind: ind,
                                    }));
                                  }}
                                  style={
                                    item.sortingVale !== "action"
                                      ? { cursor: "pointer" }
                                      : {}
                                  }
                                >
                                  {item.heading}
                                  {item.sortingVale !== "action" && (
                                    <span>
                                      {ind !== iconData.ind && (
                                        <i
                                          className="fa fa-sort ms-2 fs-12"
                                          style={{ opacity: "0.3" }}
                                        />
                                      )}
                                      {ind === iconData.ind &&
                                        (iconData.complete ? (
                                          <i
                                            className="fa fa-arrow-down ms-2 fs-12"
                                            style={{ opacity: "0.7" }}
                                          />
                                        ) : (
                                          <i
                                            className="fa fa-arrow-up ms-2 fs-12"
                                            style={{ opacity: "0.7" }}
                                          />
                                        ))}
                                    </span>
                                  )}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {!loading &&
                              userData?.map((data, ind) => (
                                <tr key={ind}>
                                  <td>{page * size + ind + 1}</td>
                                  <td>
                                    {data?.session?.name}
                                    {data?.session?.sessionType?.name &&
                                      `(${data?.session?.sessionType?.name})`}
                                  </td>
                                  <td>
                                    {data?.date
                                      ? new Date(data?.date).toLocaleString()
                                      : ""}
                                  </td>
                                  <td>{data?.status}</td>
                                </tr>
                              ))}

                            {loading && (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            )}

                            {!loading && userData?.length === 0 && (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  No data found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* PAGINATION FOOTER */}
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                        <div className="dataTables_info">
                          <span>
                            Page{" "}
                            <strong>
                              {currentStart + 1} of {totalPages}
                            </strong>
                          </span>
                        </div>
                        <div className="dataTables_paginate paging_simple_numbers">
                          <Link
                            className={`paginate_button previous ${
                              page === 0 ? "disabled" : ""
                            }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (page > 0) setPage(page - 1);
                            }}
                          >
                            Previous
                          </Link>

                          <Link
                            className={`paginate_button next ${
                              page + 1 >= totalPages ? "disabled" : ""
                            }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (page + 1 < totalPages) setPage(page + 1);
                            }}
                          >
                            Next
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>

              {/* GRID VIEW */}
              <Tab.Pane eventKey="Grid" className="col-lg-12">
                <div className="row">
                  {userData?.map((item, ind) => (
                    <div
                      className="col-lg-4 col-md-6 col-sm-6 col-12"
                      key={ind}
                    >
                      <div className="card card-profile">
                        <div className="card-header justify-content-end pb-0 border-0">
                          {/* <Dropdown>
                            <Dropdown.Toggle
                              as="button"
                              className="btn btn-link i-false"
                              type="button"
                            >
                              <span className="dropdown-dots fs--1"></span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              align="end"
                              className="dropdown-menu dropdown-menu-right border py-0"
                            >
                              <div className="py-2">
                                <Link
                                  to="/super-admin/add-user"
                                  state={{ user: item, mode: "edit" }}
                                  className="dropdown-item"
                                >
                                  Edit
                                </Link>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown> */}
                        </div>
                        <div className="card-body pt-2">
                          <div className="text-center">
                            <div className="profile-photo">
                              <img
                                src={IMAGES?.smallpic2}
                                width="100"
                                className="img-fluid rounded-circle"
                                alt=""
                              />
                            </div>
                            <ul className="list-group mb-3 list-group-flush">
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Session:</span>
                                <span>{item?.session?.sessionType?.name}</span>
                              </li>
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Attendance Date:</span>
                                <span>
                                  {item?.date
                                    ? new Date(item?.date).toLocaleString()
                                    : ""}
                                </span>
                              </li>
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Status:</span>
                                <span className="mb-0">{item?.status}</span>
                              </li>
                            </ul>

                            {/* <Link
                              to="/admin/about-attendance"
                              state={{ user: item }}
                              className="btn btn-outline-primary btn-rounded mt-3 px-4"
                            >
                              Read More
                            </Link> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  {loading && (
                    <div className="col-12 text-center my-3">Loading...</div>
                  )}
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>

      <ForgetPasswordModal
        show={forgetModal}
        onClose={() => setForgetModal(false)}
        userData={selectedUser}
      />

      <CoachAttendenceQrModal
        show={qrCodeModal}
        onClose={() => setQrCodeModal(false)}
        url="test-url-coach-attendence"
      />
    </>
  );
};

export default PlayersAttendance;
